import React, { useState } from "react";
import { ListGroup, ListGroupItem, Label } from "reactstrap";
import PropTypes from "prop-types";

import RecurringCommissionTab from "./RecurringCommissionTab";
import EventCommissionTab from "./EventCommissionTab";

const CommissionsTabs = ({
  recurrings,
  events,
  loading,
  recurring,
  event,
  recurringErrors,
  eventErrors,
  handleChange,
  setSubassets,
  services,
}) => {
  const [collapsed, setCollapsed] = useState({
    recurring: false,
    event: false,
  });

  const toggle = (section) => {
    setCollapsed((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  return (
    <div>
      <ListGroup>
        {/* Recurring Commissions Section */}
        <ListGroupItem
          onClick={() => toggle("recurring")}
          style={{ cursor: "pointer", marginTop: 5, backgroundColor: "#607d8b" }}
        >
          <Label
            style={{
              color: "white",
              fontWeight: 500,
              fontSize: "15px",
              display: "block",
            }}
          >
            Recurring
            <div style={{ float: "right" }}>
              {collapsed.recurring ? (
                <i className="fa fa-chevron-down" />
              ) : (
                <i className="fa fa-chevron-right" />
              )}
            </div>
          </Label>
        </ListGroupItem>
        {collapsed.recurring && (
          <ListGroupItem>
            <RecurringCommissionTab
              recurrings={recurrings}
              loading={loading}
              recurring={recurring}
              recurringErrors={recurringErrors}
              handleChange={handleChange}
              setSubassets={setSubassets}
              services={services}
            />
          </ListGroupItem>
        )}

        {/* Event Commissions Section */}
        <ListGroupItem
          onClick={() => toggle("event")}
          style={{ cursor: "pointer", marginTop: 5, backgroundColor: "#607d8b" }}
        >
          <Label
            style={{
              color: "white",
              fontWeight: 500,
              fontSize: "15px",
              display: "block",
            }}
          >
            Event
            <div style={{ float: "right" }}>
              {collapsed.event ? <i className="fa fa-chevron-down" /> : <i className="fa fa-chevron-right" />}
            </div>
          </Label>
        </ListGroupItem>
        {collapsed.event && (
          <ListGroupItem>
            <EventCommissionTab
              events={events}
              loading={loading}
              event={event}
              eventErrors={eventErrors}
              handleChange={handleChange}
              setSubassets={setSubassets}
              services={services}
            />
          </ListGroupItem>
        )}
      </ListGroup>
    </div>
  );
};

CommissionsTabs.propTypes = {
  recurrings: PropTypes.array.isRequired,
  events: PropTypes.array.isRequired,
  recurring: PropTypes.array.isRequired,
  event: PropTypes.array.isRequired,
  recurringErrors: PropTypes.object.isRequired,
  eventErrors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  setSubassets: PropTypes.func.isRequired,
  services: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default CommissionsTabs;
